import './index.scss';

let notification: HTMLDivElement;

const createNotification = (style?: string) => {
    const el = document.createElement('div');
    el.classList.add('toast');
    if (style) {
        el.classList.add(style);
    }
    document.body.appendChild(el);
    return el;
};

let timerId: number | null;

export default function toast(content?: string, duration: number = 1000, style?: string) {
    // use single instance
    if (!notification) {
        notification = createNotification(style);
    }

    if (!content) {
        notification.classList.add('toast--hide');
        timerId = null;
        return;
    }

    notification.classList.remove('toast--hide');
    notification.innerText = content;
    if (!timerId) {
        timerId = window.setTimeout(() => {
            notification.classList.add('toast--hide');
            timerId = null;
        }, duration);
    }
}
